export const pictures = [
  { src: "/innovaw.jpg", title: "Innova Women 2019", by: "Someone" },
  {
    src: "/feriaLibro.jpg",
    title: "Feria del libro 2019, Santa Cruz, Bolivia",
    by: "Someone",
  },
  {
    src: "/flisol2019.jpg",
    title: "FLISOL 2019, Santa Cruz, Bolivia",
    by: "Someone",
  },
  {
    src: "/hackmeetinglp2019.jpg",
    title: "Hackmeeting 2019, La Paz, Bolivia",
    by: "Someone",
  },
];
